interface Props {
  className?: string;
}
export const HamburgerIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <mask
        id="mask0_1231_8014"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="var(--swapper-text-color)" />
      </mask>
      <g mask="url(#mask0_1231_8014)">
        <path
          d="M3 7V5H21V7H3ZM3 19V17H21V19H3ZM3 13V11H21V13H3Z"
          className={`${className}`}
          fill="var(--swapper-text-color)"
        />
      </g>
    </svg>
  );
};
